import React from 'react';
import styles from './BlueprintCard.module.css';

interface Props {
  tag: string;
}

const BlueprintTag = ({ tag }: Props) => <span className={styles.tag}>{tag}</span>;

export default BlueprintTag;
